/**
 * Token-preserving redirect. Substitutes any `:param` in `to` with the
 * matching route param before navigating. Used to 301 legacy credential
 * URLs (/verify/:token, /certificate/:token) to
 * their canonical /credentials/... equivalents.
 */
import { useLayoutEffect } from "react";
import { Navigate, useParams, useLocation } from "react-router-dom";

export function TokenRedirect({ to }: { to: string }) {
  const params = useParams();
  const location = useLocation();
  const destination = to.replace(/:([a-zA-Z_][a-zA-Z0-9_]*)/g, (_, k) => encodeURIComponent(params[k] ?? ""));

  useLayoutEffect(() => {
    // SEO signal: mark the legacy source as canonical → destination.
    const link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    link.setAttribute("href", `${typeof window !== "undefined" ? window.location.origin : ""}${destination}`);
    document.head.appendChild(link);
    const robots = document.createElement("meta");
    robots.setAttribute("name", "robots");
    robots.setAttribute("content", "noindex,follow");
    document.head.appendChild(robots);
    return () => {
      link.remove();
      robots.remove();
    };
  }, [destination]);

  return <Navigate to={{ pathname: destination, search: location.search }} replace />;
}
